import React, { FC } from 'react';
import { useDesktopLayout } from '../hooks/useDesktopLayout';
// import { VideoAspectRatio } from '../common/components/VideoAspectRatio/VideoAspectRatio';
// import { Spinner } from '../common/components/Spinner/Spinner';
import { Classic } from './components/Classic/Classic';
import { ComingSoon } from '../common/components/ComingSoon/ComingSoon';
// import { useChannelVideos } from '../hooks/useChannelVideos';

export const DesktopWidget: FC = () => {
  const { isClassic } = useDesktopLayout();
  // const { videosLoading } = useChannelVideos();

  // console.log('###', videosLoading, videos);
  // if (videosLoading) {
  //   return (
  //     <VideoAspectRatio>
  //       <Spinner />
  //     </VideoAspectRatio>
  //   );
  // }

  // TODO: loadable: https://bo.wix.com/wix-docs/fe-guild/viewer-platform/articles/loadable-components-in-ooi-apps
  if (isClassic) {
    return <Classic />;
  }

  return <ComingSoon />;
};
